import script from "./MoveWarehouseModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoveWarehouseModal.vue?vue&type=script&lang=ts&setup=true"

import "./MoveWarehouseModal.vue?vue&type=style&index=0&id=e5cfab0a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5cfab0a"]])

export default __exports__